import { LOCATION_CHANGE } from 'connected-react-router';

import {
  ADD_RING_GROUPS_START,
  ADD_RING_GROUPS_SUCCESS,
  ADD_RING_GROUPS_ERROR,
  SHOW_RING_GROUP_START,
  SHOW_RING_GROUP_SUCCESS,
  SHOW_RING_GROUP_ERROR,
  CREATE_RING_GROUP_START,
  CREATE_RING_GROUP_SUCCESS,
  CREATE_RING_GROUP_ERROR,
  UPDATE_RING_GROUP_START,
  UPDATE_RING_GROUP_SUCCESS,
  UPDATE_RING_GROUP_ERROR,
  ADD_SUBGROUP_TO_RINGGROUP_START,
  ADD_SUBGROUP_TO_RINGGROUP_SUCCESS,
  ADD_SUBGROUP_TO_RINGGROUP_ERROR,
  DELETE_SUBGROUP_FROM_RINGGROUP_START,
  DELETE_SUBGROUP_FROM_RINGGROUP_SUCCESS,
  DELETE_SUBGROUP_FROM_RINGGROUP_ERROR,
} from '../constants/RingGroup';

const defaultState = {
  path: null,

  item: {},
  itemLoading: false,
  itemFetched: false,

  items: [],
  itemsFetched: false,
  itemsLoading: false,
  meta: { page: 1, pageSize: 10 },

  errorMessage: null,
};

export default function RingGroupReducer(
  state = defaultState,
  { type, payload, items, meta, errorMessage, item }
) {
  switch (type) {
    case LOCATION_CHANGE:
      return state.path === payload.pathname
        ? { ...state }
        : { ...defaultState, path: payload.pathname };

    case ADD_SUBGROUP_TO_RINGGROUP_ERROR:
      return {
        ...state,
        itemLoading: false,
        itemFetched: false,
        errorMessage,
      };

    case ADD_RING_GROUPS_START:
      return {
        ...state,
        itemsLoading: true,
        itemsFetched: false,
      };

    case ADD_RING_GROUPS_SUCCESS:
      return {
        ...state,
        itemsLoading: false,
        errorMessage: null,
        itemsFetched: true,
        items,
        meta,
      };

    case ADD_RING_GROUPS_ERROR:
      return {
        ...state,
        itemsLoading: false,
        itemsFetched: false,
        errorMessage,
      };

    case SHOW_RING_GROUP_START:
      return {
        ...state,
        itemLoading: true,
        itemFetched: false,
      };

    case SHOW_RING_GROUP_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        itemFetched: true,
        errorMessage: null,
        item,
      };

    case SHOW_RING_GROUP_ERROR:
      return {
        ...state,
        itemLoading: false,
        itemFetched: false,
        errorMessage,
      };

    case CREATE_RING_GROUP_START:
      return {
        ...state,
        itemLoading: true,
      };

    case CREATE_RING_GROUP_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        errorMessage: null,
        item,
      };

    case CREATE_RING_GROUP_ERROR:
      return {
        ...state,
        itemLoading: false,
        errorMessage,
      };

    case UPDATE_RING_GROUP_START:
      return {
        ...state,
        itemLoading: true,
      };

    case UPDATE_RING_GROUP_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        errorMessage: null,
        item,
      };

    case UPDATE_RING_GROUP_ERROR:
      return {
        ...state,
        itemLoading: false,
        errorMessage,
      };

    default:
      return state;
  }
}
